/**
 * Created by lenovo on 2017/5/11.
 */
import React, {
    Component,
    PropTypes
} from 'react';
import moment from "moment";
import {
    Link
} from "react-router";
import userService from 'SERVICES/ella/userService'
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
import ellaService from 'SERVICES/purifier/ella/ellaService'
import Tip from 'COMPONENT/tip'
import {language,pageOption} from 'UTIL/common'
import Modal from 'COMPONENT/modal'
import {timesTampsToData} from 'CONFIG/function'
import ModalDel from 'CONFIG/component/ModalDel'
import bumpService from 'SERVICES/purifier/bump/bumpService'
const returnMsg=(body)=>{
    if (body.code == 8001) {
        $("#success_msg").text(body.msg);
        $("#success_tip").removeClass("hidden");
        $("#success_tip").focus();
        setTimeout(function() {
            $("#success_tip").addClass("hidden");
        }, 3000);
    } else {
        $("#error_msg").text(body.msg);
        $("#error_tip").removeClass("hidden");
        $("#error_tip").focus();
        setTimeout(function() {
            $("#error_tip").addClass("hidden");
        }, 3000);
    }
}
import LongSearchInput from 'CONFIG/component/search/longSearchInput'
export default class AdministratorsList extends Component {
    constructor(props) {
        super(props);
        this.delList = this.delList;
        // this.delClick = this.delClick;
        this.handle = this.handle.bind(this);
        this.search = this.search.bind(this);
        this.status = this.status.bind(this);
        this.gmtCreat = this.gmtCreat.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.state = {
            list: [],
            size: 10,
            current: 1,
            total: 0,
            delRow: {id:"",name:""},
            disableId : '',
            enableId : '',
        };
    }
    componentDidMount() {
        this.onPageChange(this.state.current,this.state.size);
    }
    handle(cell, row) {
        //0 启用 1 禁用
        var div = row.state == 0?<a className="btn btn-sm btn-danger" data-target="#disable" data-toggle="modal"
                                    onClick={this.disableClick.bind(this,row.id)}>{language()['disable']}</a>:
            <a className="btn btn-sm btn-dropbox" data-target="#enable" data-toggle="modal"
               onClick={this.enableClick.bind(this,row.id)}>{language()['enable']}</a>;

        return <div>
            {div}&nbsp;&nbsp;
            <Link  to = {"/ella/user/user/businessEdit/"+row.id} className="btn btn-sm btn-info">
                {language()['edit']}
            </Link>&nbsp;&nbsp;
            <Link  to = {"/ella/user/user/businessDetail/"+row.id} className="btn btn-warning btn-sm">
                {language()['view']}
            </Link>&nbsp;&nbsp;
            <Link  to = {"/back/dvcBase/searchBindDevice/"+row.loginName} className="btn btn-success btn-sm">
                {language()['deviceList']}
            </Link>&nbsp;&nbsp;
            <a className="btn btn-sm btn-danger" data-target="#tipModal" data-toggle="modal"
               onClick={this.delList.bind(this,row.id,row.loginName)}>{language()['delete']}</a>
        </div>
    };
    delList(id,name){
        var delRow = {
            id:id,
            loginName:name,
        };
        console.log(delRow)
        this.setState({
            delRow:delRow
        });
    }
    delClick(){
        const id = this.state.delRow.id;
        userService.bussinessDel(id).then(body=>{
            if (body.code == 8001) {
                let data = {
                    "search": this.state.delRow.loginName,
                }
                data = JSON.stringify(data);
                bumpService.searchBindList({data}).then(body=>{
                    console.log(body);
                    if(body.data.total == 0){
                        $("#success_msg").text(body.msg);
                        $("#success_tip").removeClass("hidden");
                        setTimeout(function() {
                            $("#success_tip").addClass("hidden");
                        }, 3000);
                    }else{
                        let bindList = body.data.records;
                        bindList.map(index => {
                            let data = {
                                userId : index.userId,
                                deviceId : index.deviceNo,
                                factoryId : index.factoryId,
                                productId: index.productId
                            };
                            data = JSON.stringify(data);
                            console.log(data)
                            bumpService.dvcBaseUnbindDvc({data}).then(body=>{
                                console.log(body)
                                if (body.code == 8001) {
                                    $("#success_msg").text(body.msg);
                                    $("#success_tip").removeClass("hidden");
                                    $("#success_tip").focus();
                                    setTimeout(function () {
                                        $("#success_tip").addClass("hidden");
                                    }, 3000);
                                } else {
                                    $("#error_msg").text(body.msg);
                                    $("#error_tip").removeClass("hidden");
                                    $("#error_tip").focus();
                                    setTimeout(function () {
                                        $("#error_tip").addClass("hidden");
                                    }, 3000);
                                }
                            })
                        })
                    }
                })
            } else {
                $("#error_msg").text(body.msg);
                $("#error_tip").removeClass("hidden");
                setTimeout(function() {
                    $("#error_tip").addClass("hidden");
                }, 3000);
            }
            this.onPageChange(1,this.state.size);
        });

    }
    disableClick(id){
        this.setState({
            disableId : id,
        })
    }
    enableClick(id){
        this.setState({
            enableId : id,
        })
    }
    onPageChange(page, sizePerPage, e) {
        const json = {
            current:page,
            size:sizePerPage,
            search:$("#name").val(),
        };
        const data = JSON.stringify(json);
        userService.getBusinessList({data}).then(body=>{
            console.log(body)
            if(body.data !=null) {
                this.setState({
                    current: body.data.current,
                    size: body.data.size,
                    list: body.data.records,
                    total: body.data.total
                })
            }
        })
    }
    search() {
        this.onPageChange(this.state.current,this.state.size);
    }

    disable(){
        var id = this.state.disableId; 
        userService.businessAble(id,'1').then(body=>{
            console.log(body)
            this.onPageChange(this.state.current,this.state.size);
            returnMsg(body)
        })
    }
    enable(){
        var id = this.state.enableId;
        userService.businessAble(id,'0').then(body=>{
            this.onPageChange(this.state.current,this.state.size);
            returnMsg(body)
        })
    }
    stateHandle(cell,row){
        return row.state == 0?language()['enable']:language()['disable'];
    }
    status(cell,row){
        return row.state== 0?language()['enable']:language()['disable'];
    }
    key(cell,row){
        return <div className="keyDiv" data-toggle="tooltip" data-placement="bottom" title= {row.key}>{row.key}</div>
    }
    gmtCreat(cell,row){
        return row.gmtCreat == null?"":timesTampsToData(row.gmtCreat);
	}
    reset(){
        $("#name").val('');
        this.onPageChange(1,10)
    }

    render() {
        let options = pageOption(this.state.current,this.state.size);
        options['onPageChange'] = this.onPageChange.bind(this);
        return (
            <div >
                <section className="content-header " >
                    <h1> {language()['userManage']} <small>{language()['businessList']}</small> </h1>
                </section>
                <section className="content" >
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-list"></i>
                            <h3 className="box-title">{language()['businessList']}</h3>
                            <div style={{marginRight:"10px",float:"right"}}>
                                <Link  to = "/ella/user/user/businessAdd" className="btn btn-success btn-md"  >
                                    <i className="fa fa-plus-circle"></i> {language()['add']}
                                </Link>
                            </div>
                        </div>
                        <div className="box-body">
                            <Tip ids=""/>
                            <div className="title-box">
                                <div className="clearfix">
                                    <LongSearchInput id="name" name='商户编号/商户名称/登录账户'/>

                                    <button type="button" className="btn btn-info" onClick={this.search.bind(this)}>{language()['query']}</button>&nbsp;&nbsp;
                                    <button type="button" className="btn btn-warning" id="reset" onClick={this.reset.bind(this)}>
                                        {language()['resetting']}
                                    </button>
                                </div>
                            </div>
                            <div >
                                <BootstrapTable data = {this.state.list}  remote={true} fetchInfo={{ dataTotalSize: this.state.total }} striped hover pagination={true} options={options} ref='table' height={'auto'} >
                                    <TableHeaderColumn isKey dataField='id' hidden={true}> id</TableHeaderColumn>
                                    <TableHeaderColumn dataField='userNo' width="150"> {language()['businessCode']}</TableHeaderColumn>
                                    <TableHeaderColumn dataField='merchantName' width="150">商户名称</TableHeaderColumn>
                                    <TableHeaderColumn  dataField='loginName' width="150" >{language()['loginAccount']}</TableHeaderColumn>
                                    <TableHeaderColumn  dataField='regTime' dataField='contactName' width="150">{language()['contacts']}</TableHeaderColumn>
                                    <TableHeaderColumn  dataField='regTime'  dataFormat={this.key.bind(this)}  width="150">Key</TableHeaderColumn>
                                    <TableHeaderColumn  dataField='regTime'  dataField='city' width="150">{language()['address']}</TableHeaderColumn>
                                    <TableHeaderColumn  dataField='regTime'  dataFormat={this.status.bind(this)} width="150">{language()['status']}</TableHeaderColumn>
                                    <TableHeaderColumn  dataFormat={this.gmtCreat.bind(this)} width="180" >{language()['createTime']}</TableHeaderColumn>
                                    <TableHeaderColumn  dataFormat={this.handle}  width="300" columnClassName="td-mid">{language()['operation']}</TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                        </div>
                    </div>
                </section>
                {/*<ModalDel id="tipModal" delModSure = {this.delClick.bind(this,this.state.delRow.id)}/>*/}
                <Modal modal={{"id":'enable',"title":'enable',"text":'readyEnable'}}  modalSure= {this.enable.bind(this)}/>
                <Modal modal={{"id":'disable',"title":'disable',"text":'readyDisable'}}  modalSure= {this.disable.bind(this)}/>
                <ModalDel delModSure={this.delClick.bind(this)} id="tipModal"/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/user/user/businessList.js